import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CopyrightClearanceStatusComponent } from '®shared/copyright-clearance-status/copyright-clearance-status.component';
import { CourseReserveStatusComponent } from '®shared/course-reserve-status/course-reserve-status.component';
import { FieldedItemModule } from '®shared/list-item/fielded';

import { ListItemPlaceholderComponent } from './list-item-placeholder.component';

@NgModule({
  imports: [CommonModule, FieldedItemModule],
  declarations: [
    ListItemPlaceholderComponent,
    CourseReserveStatusComponent,
    CopyrightClearanceStatusComponent,
  ],
  exports: [
    ListItemPlaceholderComponent,
    CourseReserveStatusComponent,
    CopyrightClearanceStatusComponent,
  ],
})
export class ContainerStructureCommonModule {}
